export { default, default as SimpleTaskView } from "./SimpleTaskView";
